/**
 * Upload each file on its own and report which ones made it.
 *
 * With Promise.all, one failed photo hid the ones that had been saved, and
 * retrying the batch stored those a second time.
 */
function describeUploadError(error) {
  if (error?.status === 413) {
    return 'File too large (max 10MB)';
  }
  return error?.message || 'Upload failed';
}

export async function uploadEachPhoto(files, uploadOne) {
  const results = await Promise.allSettled(files.map((file) => uploadOne(file)));

  const uploaded = [];
  const failed = [];
  results.forEach((result, i) => {
    if (result.status === 'fulfilled') {
      uploaded.push(files[i]);
    } else {
      failed.push({ file: files[i], reason: describeUploadError(result.reason) });
    }
  });
  return { uploaded, failed };
}
